'use client'

import { useEffect } from 'react'
import { useAppStore } from '@/lib/store/app-store'

// Mounted once near the root layout. Runs only on the client, after
// hydration, so it can safely touch localStorage/Intl/Date without risking
// a server/client markup mismatch — see the comment in app-store.ts.
export function AppStoreHydrator() {
  useEffect(() => {
    useAppStore.persist.rehydrate()

    const state = useAppStore.getState()
    if (state.timezone === 'UTC') {
      state.setTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone)
    }
    if (state.matchesDate === '1970-01-01') {
      state.setMatchesDate(new Date().toISOString().slice(0, 10))
    }
  }, [])

  return null
}
